// Module
var code = "<div fg-property-field-common=\"{ fieldname: true, displayname: true, placeholder: true, tooltip: false, label: true, previousfield: true }\"></div> <div fg-property-field=\"fieldValue\"> <div class=\"checkbox\"></div> </div> ";
// Exports
export default code;